import { KeyValue } from '@/main/models/common';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';
import {
  ValuatorFilterRequest,
  ValuatorBodyShopRequest,
  DeleteValuatorInsurerRequest
} from '@/main/models/request/valuatorRequest';
import {
  ValuatorBodyShopResponse,
  ValuatorSearchGridResponse
} from '@/main/models/response';
import { AxiosResponse } from 'axios';

export abstract class IValuatorApi {
  abstract getValuatorsDomain(
    request: ValuatorFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract getValuatorsGrid(
    request: ValuatorFilterRequest
  ): Promise<AxiosResponse<PaginationResponse<ValuatorSearchGridResponse>>>;

  abstract inactiveInsurerByValuator(
    request: DeleteValuatorInsurerRequest
  ): Promise<AxiosResponse>;
}
